<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-9">
                <div class="form-group">
                    <label for="pageType">Page Type</label>
                    <wj-combo-box
                        id="pageType"
                        [(ngModel)]="target.pageType"
                        name="pageType"
                        [itemsSource]="pageTypeList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="duration">Minutes</label>
                    <input id="duration" type="number" class="form-control" [(ngModel)]="target.duration" name="duration" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label for="title">Title</label>
                    <input id="title" type="text" class="form-control" [(ngModel)]="target.title" name="title" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label for="subheading">Subheading</label>
                    <input id="subheading" type="text" class="form-control" [(ngModel)]="target.subheading" name="subheading" />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
